module.exports = __webpack_public_path__ + "img/gm.21bb74e6.svg";